import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LmedidorInteligenteService {
  token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlfa2V5X2lkIjoiZTQ2MzNjZGEtYzUyYy00N2YxLTk3YTMtY2MxN2M0OWVkOTY4IiwiYXVkIjoiYXMiLCJpc3MiOiJhcyIsIm5iZiI6MTYzNjY2MzU3Nywic3ViIjoiYXBpX2tleSJ9.mISS0KyE89bSiVuSDf48T6RQnRJnLTDwy7746qDqfXM";
  headers: HttpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
    "Grpc-Metadata-Authorization": "Bearer " + this.token
  });

  tokenAU="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlfa2V5X2lkIjoiYTIwYmRjMjctYjk5ZS00NmYwLTkyZDQtMTQ1MTExYjMzOTU4IiwiYXVkIjoiYXMiLCJpc3MiOiJhcyIsIm5iZiI6MTY4NDI1NjI4Niwic3ViIjoiYXBpX2tleSJ9.1iiuwgMvwAyw2zgiqt_DP6PCj-7K85rkwa2fwmSsscw"
  headersAU: HttpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
    "Grpc-Metadata-Authorization": "Bearer " + this.tokenAU
  });

  private url_base_svc = 'https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua';
  private url_agua_quito='https://corp-190-57-148-102.uio.puntonet.ec/MarsedEpmaps/Svc';
  private url_chirpstack='https://corp-190-12-6-203.uio.puntonet.ec:8080/api';
  private url_chirpstackAU195='http://190.12.6.205:8081/api'
  constructor(private http: HttpClient) { }
  
  EjecutarServicioPost(uri,parametros) {
    return this.http.post(this.url_base_svc+uri, parametros).pipe(map(result => result));
  }
  EjecuratarServicioGet(uri,parametro){
    return this.http.get(this.url_base_svc+uri + parametro).pipe(map(result => result));
  }
  EjecutarServicioAguaQuitoPost(uri,parametros) {
    return this.http.post(this.url_agua_quito+uri, parametros).pipe(map(result => result));
  }
  //ejecutar servicios chirpStack
  EjecuratarServicioChirpStackGet(uri,token){
    return this.http.get(this.url_chirpstack+uri, { headers: this.headers }).pipe(map(result => result));
  }
    //ejecutar servicios chirpStack
  EjecuratarServicioChirpStackPost(uri,body,token){
    return this.http.post(this.url_chirpstack+uri,body, { headers: this.headers }).pipe(map(result => result));
  }
  EjecutarServicioChirpStackAUPost(uri,body){
    return this.http.post(this.url_chirpstackAU195+uri,body, { headers: this.headersAU}).pipe(map(result => result));
  }
  logintest(user) {
    return this.http.post('http://190.57.148.102:8080/api/internal/login', user).pipe(map(result => result));
  }
 getToken(){
   return this.token;
 }
  
  //Otros servicios
  /*cicloTotalPersonas(ciclo) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/totales', ciclo).pipe(map(result => result));
  }*/


  /*consultaCuentas(ruta) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/cuentas', ruta).pipe(map(result => result));
  }*/

  /*consultaNovedades(filtro) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/totales', filtro).pipe(map(result => result));
  }*/

  /*consultaCiclos(fecha) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/ciclos', fecha).pipe(map(result => result));
  }*/

  /*consultaAgrupadoConsumo(fecha) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/datos_grafico_agrupado', fecha).pipe(map(result => result));
  }*/

  /*consultarCosumoMeses(filtro): Observable<any> {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/totales', filtro).pipe(map(result => result));
  }*/
 //Clientes

 /* obtenerDatosCliente() {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/medidorinteligente').pipe(map(result => result));
  }*/
  /*obtenerDatosUsuarios(cuenta) {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartagua/api/informacioncliente/' + cuenta).pipe(map(result => result));
  }*/
   //el enlace anterior si lo tengo guardado este es el nuevo
  /* crearUsuario(usuario) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/usuario/crear', usuario).pipe(map(result => result));
  }*/
  /*obtenerListaUsuarios() {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/usuarioall').pipe(map(result => result));
  }*/
  /*editarUsuario(usuario) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/usuario/actualizar', usuario).pipe(map(result => result));
  }*/
  /*usuarioEliminar(usuario) {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/usuario/' + usuario).pipe(map(result => result));
  }*/

  //Medidor
  /*crearMedidor(medidor) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/medidor/crear', medidor).pipe(map(result => result));
  }*/

  /*obtenerDatosMedidor(medidor) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/medidorintecod',medidor).pipe(map(result => result));
  }*/

  /*obtenerDetalleMedidor(medidor) {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcant/api/detallecliente/'+medidor).pipe(map(result => result));
  }*/
  /*editarMedidor(medidor) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/medidor/actualizar', medidor).pipe(map(result => result));
  }*/
  /*listaMedidor(listaMedidor) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/listadomedintecod', listaMedidor).pipe(map(result => result));
  }*/
  /*obtenerListaMedidores() {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/medidorall').pipe(map(result => result));
  }*/

  /*medidorEliminar(medidor) {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/medidorEliminar/' + medidor).pipe(map(result => result));
  }*/
  //detalle de envios medidores
  /*detallEnvios(medidor) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/enviopaquetes', medidor).pipe(map(result => result));
  }*/

  //Gateways
  /*crearGateway(gateway) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/gateway/crear', gateway).pipe(map(result => result));
  }*/
  /*obtenerListaGateways() {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/gatewayall').pipe(map(result => result));
  }*/
  /*editarGateway(gateway) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/gateway/actualizar', gateway).pipe(map(result => result));
  }*/

  /*gatewayEliminar(gateway) {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/gatewayEliminar/' + gateway).pipe(map(result => result));
  }*/

 
 
  //gateways chirpStack
  /*gatewayListaChirp(idOrganizacion, token) {
    return this.http.get('https://corp-190-12-6-203.uio.puntonet.ec:8080/api/gateways?limit=10&organizationID=' + idOrganizacion, { headers: token }).pipe(map(result => result));
  }*/
  /*devicesListaChirp(idAplicacion, token) {
    return this.http.get('https://corp-190-12-6-203.uio.puntonet.ec:8080/api/devices?limit=100&applicationID=' + idAplicacion, { headers: token }).pipe(map(result => result));
  }*/
  /*gatewayEditar(gateway){
    return this.http.post('', gateway).pipe(map(result => result));
  }*/
  /*obtenerDevicesActivos( token) {
    return this.http.get('https://corp-190-12-6-203.uio.puntonet.ec:8080/api/internal/devices/summary?organizationID=2' , { headers: token }).pipe(map(result => result));
  }*/
  /*obtenerGatewayActivos(token) {
    return this.http.get('https://corp-190-12-6-203.uio.puntonet.ec:8080/api/internal/gateways/summary?organizationID=2', { headers: token }).pipe(map(result => result));
  }
*/

  //servicios complementarios
  /*obtenerListaGPS(lista) {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/listadoGPS', lista).pipe(map(result => result));
  }*/
  /*consultarLecturaAnterior(parametros): Observable<any> {
    return this.http.post('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/lecturaanterior', parametros).pipe(map(result => result));
  }*/
  /*obtenerCicloActual(cicloActual) {
    return this.http.post('https://www.marsedaguaquito.com.ec/MarsedEpmaps/Svc/Catalogos.svc/CicloConsultar', cicloActual).pipe(map(result => result));
  }
  */
  /*obtenerSectoRuta(sectoRuta) {
    return this.http.post('https://www.marsedaguaquito.com.ec/MarsedEpmaps/Svc/Administracion.svc/SubrutaConsultar', sectoRuta).pipe(map(result => result));
   }*/
   ////////////historicos agua quito
  /*obtenerCosumosHistoricos(filtro) {
    return this.http.post('https://www.marsedaguaquito.com.ec/MarsedEpmaps/Svc/Lectura.svc/LecturaHistoricoConsumoConsultar', filtro).pipe(map(result => result));
  }*/
   /*ConsultarFotos(id) {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/fotos/' + id).pipe(map(result => result));
  }*/
  /*ConusltadatosCliente(cuenta): Observable<any> {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/informacioncliente/' +cuenta).pipe(map(result => result));
  }*/
  /*ConsultarPliego(): Observable<any> {
    return this.http.get('https://corp-190-57-148-102.uio.puntonet.ec/svcsmartAgua/api/MiPliego/').pipe(map(result => result));
  }*/
  

}
